
export const EXPORT_TYPE = {
    PDF: "pdf",
    DOC: "doc"
}
